import _ from 'underscore';
import moment from 'moment';

angular.module('am4').directive('timepicker', function() {
    return {
        restrict: 'A',
        replace: true,
        require: 'ngModel',
        scope: {
            pickerDisabled: '='
        },
        link: function(scope, elem, attrs, ngModelCtrl) {
            var init,
                pullTimeFromModel,
                resetToNull,
                setupSelectOptions;
            init = function() {
                setupSelectOptions();
                return resetToNull();
            };
            setupSelectOptions = function() {
                scope.useAmPm = attrs.useAmPm != null ? attrs.useAmPm === true || attrs.useAmPm === 'true' : true;
                scope.hourOptions = scope.useAmPm ? _.range(1, 13) : _.range(24);
                scope.minuteOptions = _.range(60);
                scope.amPmOptions = ['AM', 'PM'];
            };
            resetToNull = function() {
                scope.hour = null;
                scope.minute = null;
                scope.amPm = null;
            };
            ngModelCtrl.$render = function() {
                return pullTimeFromModel();
            };
            pullTimeFromModel = function() {
                var d;
                if (angular.isDate(ngModelCtrl.$viewValue)) {
                    d = moment(ngModelCtrl.$viewValue);
                    scope.minute = d.minute();
                    scope.hour = +d.format('h');
                    scope.amPm = d.format('A');
                    return;
                }
                return resetToNull();

            };
            scope.setTimeFromFields = function() {
                var d,
                    hour;
                if ((ngModelCtrl.$viewValue != null) && angular.isDate(ngModelCtrl.$viewValue)) {
                    d = moment(ngModelCtrl.$viewValue);
                }

                if (scope.hour === 12 && scope.amPm === 'AM') {
                    hour = 0;
                } else if (scope.hour !== 12 && scope.amPm === 'PM') {
                    hour = scope.hour + 12;
                } else {
                    hour = scope.hour;
                }

                d = d.hour(hour).minute(scope.minute).toDate();

                return ngModelCtrl.$setViewValue(d);
            };
            return init();
        },
        template: require('./timePicker.html')
    };
});



// WEBPACK FOOTER //
// ./src/app/directives/timePicker.js